import { RadialLinearScale } from "chart.js";
import {
  TAU,
  addRoundedRectPath,
  isNullOrUndef,
  renderText,
  toFont,
  toPadding,
  toTRBLCorners
} from "chart.js/helpers";
import { isMobile } from 'react-device-detect';

const DEBUG = false;

function fragmentText(ctx, text, maxWidth) {
    var words = text.split(' '),
        lines = [],
        line = "";
    if (ctx.measureText(text).width < maxWidth) {
        return [text];
    }
    while (words.length > 0) {
        var split = false;
        while (ctx.measureText(words[0]).width >= maxWidth) {
            var tmp = words[0];
            words[0] = tmp.slice(0, -1);
            if (!split) {
                split = true;
                words.splice(1, 0, tmp.slice(-1));
            } else {
                words[1] = tmp.slice(-1) + words[1];
            }
        }
        if (ctx.measureText(line + words[0]).width < maxWidth) {
            line += words.shift() + " ";
        } else {
            lines.push(line);
            line = "";
        }
        if (words.length === 0) {
            lines.push(line);
        }
    }
    return lines;
}

function drawSingleLabel(scale, ctx, i, labelCount, originX, originY, images) {
  //ctx.fillStyle = "red";
  //ctx.fillRect(originX-4, originY-4,8,8); // fill in the pixel at (10,10)

  let eachAngle = 360/labelCount

  ctx.save();
  ctx.translate(originX, originY);

  let angle;
  let txtAlign = "left"
  let calc = -90+(eachAngle*i)
  if (calc > 90) {
    calc+=180
    txtAlign = "right"
  }
  angle = calc * Math.PI / 180
  ctx.rotate(angle);

  let allSkills = scale?.chart?.config?._config?.options?.scales?.r?.customData?.allSkillsWithScores
  let finalImage
  if (allSkills) {
    let label = scale?.chart?.scales?.r?._pointLabels[i]
    let find = allSkills[i]
    if (label && find?.family) {
      if (find?.score < find?.seuil) {
        let findImage = images.find((el) => el.family  === "error")
        if (findImage) {
          finalImage = findImage
        }
      } else {
        let findImage = images.find((el) => el.family  === find?.family)
        if (findImage) {
          finalImage = findImage
        }
      }
    }
  }


  const backdropWidth = 100;
  const backdropHeight = 30;
  let backdropLeft = 0
  if (calc > 90) {
    backdropLeft = - backdropWidth
  }
  let backdropTop = - backdropHeight / 2

  //ctx.fillStyle = "red";
  //ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);

  let fontSize = "13px"
  let lineHeight = 13
  let maxWidthText = 100
  if (isMobile) {
    fontSize = "10px"
    lineHeight = 10
    maxWidthText = 70
  }

  ctx.font = "300 "+fontSize+" Circular";
  ctx.fillStyle = "rgba(0,0,0,0.8)"
  ctx.textAlign = txtAlign
  let splitText = fragmentText(ctx, scale._pointLabels[i], maxWidthText)
  if (splitText.length === 1) {
    let textMetrics = ctx.measureText(splitText[0]);
    ctx.fillText(splitText[0], 0, +3)
    //on place aussi l'image
    let xImage
    if (txtAlign === "left") {
      xImage = textMetrics?.width+5
    } else if (txtAlign === "right") {
      xImage = -textMetrics?.width-15-5
    }
    if (finalImage) {
      let displayImg = new Image()
      displayImg.src = finalImage?.src
      ctx?.drawImage(displayImg, xImage, 0-7.5-1, 15, 15);
    }
  } else if (splitText.length > 1) {
    let maxWidth = 0
    let xImage
    splitText.forEach((text, index) => {
      if (index < 2) {
        let textMetrics = ctx.measureText(text);
        if (textMetrics?.width > maxWidth) { maxWidth = textMetrics?.width }
        ctx.fillText(text, 0, -3 + (index*lineHeight) );
      }
    })

    if (txtAlign === "left") {
      xImage = maxWidth+5
    } else if (txtAlign === "right") {
      xImage = -maxWidth-15-5
    }
    if (finalImage) {
      let displayImg = new Image()
      displayImg.src = finalImage?.src
      ctx?.drawImage(displayImg, xImage, 0-7.5-1, 15, 15);
    }
  }


  ctx.restore();
}


function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
  const ctx = scale.ctx;
  const circular = gridLineOpts.circular;

  const { color, lineWidth } = gridLineOpts;

  if ((!circular && !labelCount) || !color || !lineWidth || radius < 0) {
    return;
  }

  ctx.save();
  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;
  ctx.setLineDash(borderOpts.dash);
  ctx.lineDashOffset = borderOpts.dashOffset;

  ctx.beginPath();
  pathRadiusLine(scale, radius, circular, labelCount);
  ctx.closePath();
  ctx.stroke();
  ctx.restore();
}

function drawTick(scale, radius, tick) {
  const ctx = scale.ctx;
  ctx.save();

  let fontSize = "9px"
  let lineHeight = 11

  let text = Math.ceil(tick?.value)+"%"
  let textMetrics = ctx.measureText(text);

  let x = scale.xCenter - (textMetrics.width/2)
  let y = scale.yCenter - radius + lineHeight + 1

  ctx.translate(x, y);
  ctx.font = "300 "+fontSize+" Circular";
  ctx.fillStyle = "rgba(0,0,0,0.8)"
  ctx.fillText(text, 0, 0)

  ctx.restore();
}


function pathRadiusLine(scale, radius, circular, labelCount) {
  const { ctx } = scale;
  if (circular) {
    // Draw circular arcs between the points
    ctx.arc(scale.xCenter, scale.yCenter, radius, 0, TAU);
  } else {
    // Draw straight lines connecting each index
    let pointPosition = scale.getPointPosition(0, radius);
    ctx.moveTo(pointPosition.x, pointPosition.y);

    for (let i = 1; i < labelCount; i++) {
      pointPosition = scale.getPointPosition(i, radius);
      ctx.lineTo(pointPosition.x, pointPosition.y);
    }
  }
}

// https://www.chartjs.org/docs/latest/developers/axes.html
class CustomRadialLinearScale extends RadialLinearScale {
  // https://github.com/chartjs/Chart.js/blob/master/src/scales/scale.radialLinear.js
  drawGrid() {
    const ctx = this.ctx;
    const opts = this.options;
    const { angleLines, grid, border } = opts;
    const labelCount = this._pointLabels.length;

    let i, offset, position;

    /*if (opts.pointLabels.display) {
      drawPointLabels(this, labelCount);
    }*/

    if (grid.display) {
      this.ticks.forEach((tick, index) => {
        if (index !== 0) {
          offset = this.getDistanceFromCenterForValue(tick.value);
          const context = this.getContext(index);
          const optsAtIndex = grid.setContext(context);
          const optsAtIndexBorder = border.setContext(context);

          drawRadiusLine(
            this,
            optsAtIndex,
            offset,
            labelCount,
            optsAtIndexBorder
          );
        }

        drawTick(
          this,
          offset,
          tick
        );
      });
    }



    if (angleLines.display) {
      ctx.save();

      for (i = labelCount - 1; i >= 0; i--) {
        const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
        const { color, lineWidth } = optsAtIndex;

        if (!lineWidth || !color) {
          continue;
        }

        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = color;

        ctx.setLineDash(optsAtIndex.borderDash);
        ctx.lineDashOffset = optsAtIndex.borderDashOffset;

        offset = this.getDistanceFromCenterForValue(
          opts.ticks.reverse ? this.min : this.max
        );
        position = this.getPointPosition(i, offset);
        ctx.beginPath();
        ctx.moveTo(this.xCenter, this.yCenter);
        ctx.lineTo(position.x, position.y);
        ctx.stroke();

        let positionLabel = this.getPointPosition(i, offset+8);

        const images = [
          {family : 'communication', src:`data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNy45MTY2NyIgY3k9IjcuOTE2NjciIHI9IjUuNDE2NjciIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4xNTgzMiAxLjE5MTM1QzUuODI3NTIgMC40NjIyNTQgNi44MTUwNyAwIDcuOTE2NjcgMEM5LjAxODE4IDAgMTAuMDA1NyAwLjQ2MjIwOCAxMC42NzQ5IDEuMTkxMjRDMTEuNjkyNCAxLjEyMzg5IDEyLjczNTggMS40NTg1OCAxMy41MTQ4IDIuMTk2NTlDMTQuMjkzOCAyLjkzNDYgMTQuNjQ3MSAzLjkyMzE1IDE0LjU3NjEgNC44ODcwN0MxNS4zNDU1IDUuNTIxMDQgMTUuODMzMyA2LjQ1NjU0IDE1LjgzMzMgNy41QzE1LjgzMzMgOC41NDM2OSAxNS4zNDUzIDkuNDc5MzEgMTQuNTc1NyAxMC4xMTMzQzE0LjY0NjYgMTEuMDc3MSAxNC4yOTMzIDEyLjA2NTQgMTMuNTE0NCAxMi44MDMzQzEyLjczNTUgMTMuNTQxMiAxMS42OTIzIDEzLjg3NTggMTAuNjc1IDEzLjgwODdDMTAuMDA1OCAxNC41Mzc4IDkuMDE4MjYgMTUgNy45MTY2NyAxNUM2LjgxNTE1IDE1IDUuODI3NjQgMTQuNTM3OCA1LjE1ODQ1IDEzLjgwODhDNC4xNDA5NiAxMy44NzYyIDMuMDk3NDkgMTMuNTQxNSAyLjMxODQ2IDEyLjgwMzVDMS41Mzk0NSAxMi4wNjU0IDEuMTg2MTcgMTEuMDc2OCAxLjI1NzI2IDEwLjExMjlDMC40ODc4MjEgOS40Nzg5MiAwIDguNTQzNDYgMCA3LjVDMCA2LjQ1NjQ2IDAuNDg3ODcgNS41MjA5NSAxLjI1NzM3IDQuODg2OTdDMS4xODYzNiAzLjkyMzEyIDEuNTM5NjYgMi45MzQ2NyAyLjMxODYgMi4xOTY3MkMzLjA5NzU1IDEuNDU4NzcgNC4xNDA5MiAxLjEyNDA3IDUuMTU4MzIgMS4xOTEzNVpNMTAuODQ4MSA2LjEwNDU0QzExLjA0MzYgNS44NDUyOCAxMC45ODAyIDUuNDg0OTcgMTAuNzA2NSA1LjI5OTc3QzEwLjQzMjkgNS4xMTQ1NyAxMC4wNTI1IDUuMTc0NjIgOS44NTcwMiA1LjQzMzlMNy4yMjk5OSA4LjkxODE1TDUuOTExMzggNy42NjlDNS42NzM1NiA3LjQ0MzY5IDUuMjg3OTggNy40NDM2OSA1LjA1MDE2IDcuNjY5QzQuODEyMzQgNy44OTQzMSA0LjgxMjM0IDguMjU5NTQgNS4wNTAxNiA4LjQ4NDg1TDYuODc3MTEgMTAuMjE1NkM3LjAwMzY5IDEwLjMzNTUgNy4xNzk0OCAxMC4zOTY2IDcuMzU3OTUgMTAuMzgyNkM3LjUzNjM0IDEwLjM2ODcgNy42OTkyMiAxMC4yODEgNy44MDMyNCAxMC4xNDNMMTAuODQ4MSA2LjEwNDU0WiIgZmlsbD0iI0ZGNTEwNiIvPgo8L3N2Zz4K`},
          {family : 'efficacite', src : `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNy45MTY2NyIgY3k9IjcuOTE2NjciIHI9IjUuNDE2NjciIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4xNTgzMiAxLjE5MTM1QzUuODI3NTIgMC40NjIyNTQgNi44MTUwNyAwIDcuOTE2NjcgMEM5LjAxODE4IDAgMTAuMDA1NyAwLjQ2MjIwOCAxMC42NzQ5IDEuMTkxMjRDMTEuNjkyNCAxLjEyMzg5IDEyLjczNTggMS40NTg1OCAxMy41MTQ4IDIuMTk2NTlDMTQuMjkzOCAyLjkzNDYgMTQuNjQ3MSAzLjkyMzE1IDE0LjU3NjEgNC44ODcwN0MxNS4zNDU1IDUuNTIxMDQgMTUuODMzMyA2LjQ1NjU0IDE1LjgzMzMgNy41QzE1LjgzMzMgOC41NDM2OSAxNS4zNDUzIDkuNDc5MzEgMTQuNTc1NyAxMC4xMTMzQzE0LjY0NjYgMTEuMDc3MSAxNC4yOTMzIDEyLjA2NTQgMTMuNTE0NCAxMi44MDMzQzEyLjczNTUgMTMuNTQxMiAxMS42OTIzIDEzLjg3NTggMTAuNjc1IDEzLjgwODdDMTAuMDA1OCAxNC41Mzc4IDkuMDE4MjYgMTUgNy45MTY2NyAxNUM2LjgxNTE1IDE1IDUuODI3NjQgMTQuNTM3OCA1LjE1ODQ1IDEzLjgwODhDNC4xNDA5NiAxMy44NzYyIDMuMDk3NDkgMTMuNTQxNSAyLjMxODQ2IDEyLjgwMzVDMS41Mzk0NSAxMi4wNjU0IDEuMTg2MTcgMTEuMDc2OCAxLjI1NzI2IDEwLjExMjlDMC40ODc4MjEgOS40Nzg5MiAwIDguNTQzNDYgMCA3LjVDMCA2LjQ1NjQ2IDAuNDg3ODcgNS41MjA5NSAxLjI1NzM3IDQuODg2OTdDMS4xODYzNiAzLjkyMzEyIDEuNTM5NjYgMi45MzQ2NyAyLjMxODYgMi4xOTY3MkMzLjA5NzU1IDEuNDU4NzcgNC4xNDA5MiAxLjEyNDA3IDUuMTU4MzIgMS4xOTEzNVpNMTAuODQ4MSA2LjEwNDU0QzExLjA0MzYgNS44NDUyOCAxMC45ODAyIDUuNDg0OTcgMTAuNzA2NSA1LjI5OTc3QzEwLjQzMjkgNS4xMTQ1NyAxMC4wNTI1IDUuMTc0NjIgOS44NTcwMiA1LjQzMzlMNy4yMjk5OSA4LjkxODE1TDUuOTExMzggNy42NjlDNS42NzM1NiA3LjQ0MzY5IDUuMjg3OTggNy40NDM2OSA1LjA1MDE2IDcuNjY5QzQuODEyMzQgNy44OTQzMSA0LjgxMjM0IDguMjU5NTQgNS4wNTAxNiA4LjQ4NDg1TDYuODc3MTEgMTAuMjE1NkM3LjAwMzY5IDEwLjMzNTUgNy4xNzk0OCAxMC4zOTY2IDcuMzU3OTUgMTAuMzgyNkM3LjUzNjM0IDEwLjM2ODcgNy42OTkyMiAxMC4yODEgNy44MDMyNCAxMC4xNDNMMTAuODQ4MSA2LjEwNDU0WiIgZmlsbD0iIzRGMzlGRiIvPgo8L3N2Zz4K`},
          {family : 'leadership', src : `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNy45MTY2NyIgY3k9IjcuOTE2NjciIHI9IjUuNDE2NjciIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4xNTgzMiAxLjE5MTM1QzUuODI3NTIgMC40NjIyNTQgNi44MTUwNyAwIDcuOTE2NjcgMEM5LjAxODE4IDAgMTAuMDA1NyAwLjQ2MjIwOCAxMC42NzQ5IDEuMTkxMjRDMTEuNjkyNCAxLjEyMzg5IDEyLjczNTggMS40NTg1OCAxMy41MTQ4IDIuMTk2NTlDMTQuMjkzOCAyLjkzNDYgMTQuNjQ3MSAzLjkyMzE1IDE0LjU3NjEgNC44ODcwN0MxNS4zNDU1IDUuNTIxMDQgMTUuODMzMyA2LjQ1NjU0IDE1LjgzMzMgNy41QzE1LjgzMzMgOC41NDM2OSAxNS4zNDUzIDkuNDc5MzEgMTQuNTc1NyAxMC4xMTMzQzE0LjY0NjYgMTEuMDc3MSAxNC4yOTMzIDEyLjA2NTQgMTMuNTE0NCAxMi44MDMzQzEyLjczNTUgMTMuNTQxMiAxMS42OTIzIDEzLjg3NTggMTAuNjc1IDEzLjgwODdDMTAuMDA1OCAxNC41Mzc4IDkuMDE4MjYgMTUgNy45MTY2NyAxNUM2LjgxNTE1IDE1IDUuODI3NjQgMTQuNTM3OCA1LjE1ODQ1IDEzLjgwODhDNC4xNDA5NiAxMy44NzYyIDMuMDk3NDkgMTMuNTQxNSAyLjMxODQ2IDEyLjgwMzVDMS41Mzk0NSAxMi4wNjU0IDEuMTg2MTcgMTEuMDc2OCAxLjI1NzI2IDEwLjExMjlDMC40ODc4MjEgOS40Nzg5MiAwIDguNTQzNDYgMCA3LjVDMCA2LjQ1NjQ2IDAuNDg3ODcgNS41MjA5NSAxLjI1NzM3IDQuODg2OTdDMS4xODYzNiAzLjkyMzEyIDEuNTM5NjYgMi45MzQ2NyAyLjMxODYgMi4xOTY3MkMzLjA5NzU1IDEuNDU4NzcgNC4xNDA5MiAxLjEyNDA3IDUuMTU4MzIgMS4xOTEzNVpNMTAuODQ4MSA2LjEwNDU0QzExLjA0MzYgNS44NDUyOCAxMC45ODAyIDUuNDg0OTcgMTAuNzA2NSA1LjI5OTc3QzEwLjQzMjkgNS4xMTQ1NyAxMC4wNTI1IDUuMTc0NjIgOS44NTcwMiA1LjQzMzlMNy4yMjk5OSA4LjkxODE1TDUuOTExMzggNy42NjlDNS42NzM1NiA3LjQ0MzY5IDUuMjg3OTggNy40NDM2OSA1LjA1MDE2IDcuNjY5QzQuODEyMzQgNy44OTQzMSA0LjgxMjM0IDguMjU5NTQgNS4wNTAxNiA4LjQ4NDg1TDYuODc3MTEgMTAuMjE1NkM3LjAwMzY5IDEwLjMzNTUgNy4xNzk0OCAxMC4zOTY2IDcuMzU3OTUgMTAuMzgyNkM3LjUzNjM0IDEwLjM2ODcgNy42OTkyMiAxMC4yODEgNy44MDMyNCAxMC4xNDNMMTAuODQ4MSA2LjEwNDU0WiIgZmlsbD0iI0YzOTBGRiIvPgo8L3N2Zz4K`},
          {family : 'error', src : `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMTRDMTAuODY2IDE0IDE0IDEwLjg2NiAxNCA3QzE0IDMuMTM0MDEgMTAuODY2IDAgNyAwQzMuMTM0MDEgMCAwIDMuMTM0MDEgMCA3QzAgMTAuODY2IDMuMTM0MDEgMTQgNyAxNFoiIGZpbGw9IiM5Nzk3OTciLz4KPHBhdGggZD0iTTE0IDYuOTk5OTZDMTQgMTAuODUgMTAuODUgMTQgNi45OTk5OSAxNEM0Ljc2ODc2IDE0IDIuODAwMDEgMTIuOTkzNyAxLjUzMTI1IDExLjM3NUMyLjcxMjUgMTIuMzM3NSA0LjI0Mzc1IDEyLjkwNjIgNS45MDYyMyAxMi45MDYyQzkuNzU2MjMgMTIuOTA2MiAxMi45MDYyIDkuNzU2MjQgMTIuOTA2MiA1LjkwNjIzQzEyLjkwNjIgNC4yNDM3NSAxMi4zMzc1IDIuNzEyNSAxMS4zNzUgMS41MzEyNUMxMi45OTM3IDIuNzk5OTUgMTQgNC43Njg3IDE0IDYuOTk5OTZaIiBmaWxsPSIjOTc5Nzk3Ii8+CjxwYXRoIGQ9Ik0xMC4xOTM3IDEwLjE5MzdDOS45MzEyMiAxMC40NTYyIDkuNDkzNyAxMC40NTYyIDkuMjMxMjEgMTAuMTkzN0w2Ljk5OTk4IDcuOTYyNDhMNC43Njg3NCAxMC4xOTM3QzQuNTA2MjUgMTAuNDU2MiA0LjA2ODczIDEwLjQ1NjIgMy44MDYyNCAxMC4xOTM3QzMuNTQzNzUgOS45MzEyMiAzLjU0Mzc1IDkuNDkzNyAzLjgwNjI0IDkuMjMxMjFMNi4wMzc0OCA2Ljk5OTk4TDMuODA2MjQgNC43Njg3NEMzLjU0Mzc1IDQuNTA2MjUgMy41NDM3NSA0LjA2ODczIDMuODA2MjQgMy44MDYyNEM0LjA2ODczIDMuNTQzNzUgNC41MDYyNSAzLjU0Mzc1IDQuNzY4NzQgMy44MDYyNEw2Ljk5OTk4IDYuMDM3NDhMOS4yMzEyMSAzLjgwNjI0QzkuNDkzNyAzLjU0Mzc1IDkuOTMxMjIgMy41NDM3NSAxMC4xOTM3IDMuODA2MjRDMTAuNDU2MiA0LjA2ODczIDEwLjQ1NjIgNC41MDYyNSAxMC4xOTM3IDQuNzY4NzRMNy45NjI0OCA2Ljk5OTk4TDEwLjE5MzcgOS4yMzEyMUMxMC40NTYyIDkuNDkzNyAxMC40NTYyIDkuOTMxMTkgMTAuMTkzNyAxMC4xOTM3WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==`}
        ]


        drawSingleLabel(this, ctx, i, labelCount, positionLabel.x, positionLabel.y, images)
      }

      ctx.restore();
    }
  }
}

CustomRadialLinearScale.id = "derivedRadialLinearScale";
CustomRadialLinearScale.defaults = RadialLinearScale.defaults;

export default CustomRadialLinearScale;
